<template>
  <div class="track-container" ref="componentFocusTarget">

    <span class="feedback-wrapper" v-if="showFeedback">
      <span class="feedback-text">
        <p>
          If you have a moment,
          <a href="https://feedback.csc.gov.au/cgi-bin/qwebcorporate.dll?idx=R5KNER&source=MemberWebsite&InviteChannel=Web&webscheme=none" target="_blank">we'd love to hear what you think</a>
          of our Benchmark calculator, to help us to build it to better suit your needs.
        </p>
      </span>
      <a v-on:click="showFeedback = !showFeedback" class="closer"></a>
    </span>

    <div class="cols">

      <span class="track-container--results">
        <div class="track-container__inner">
          <h1>How does my super stack up?</h1>

          <div class="switcher-container" v-if="scheme === 'PSSAP' || scheme === 'ADFSuper'">
            <label class="switcher-label" for="switcher">Compare my</label>
            <span class="select-wrapper">
              <select id="switcher" v-model="switcher" class="select-wide">
                <option v-for="switcher in switcherList" :key="switcher.id" :value="switcher.value">
                  {{ switcher.text }}
                </option>
              </select>
            </span>
          </div>

          <div class="switcher-container">
            <label class="filter-label" for="filter">Filter by</label>
            <span class="select-wrapper">
              <select id="filter" v-model="filter" class="select-wide">
                <option v-for="filter in filterList" :key="filter.id" :value="filter.value">
                  {{ filter.text }}
                </option>
              </select>
            </span>
          </div>

          <div class="tracking-container">
            <p class="txt-center">
              Comparing your
              <span class="switcher-selection">{{switcherDescription}}</span>,
              <!-- against your peers, -->
              and
              <br />
              showing how you track against
              <strong>{{prettyFilterDescription}}</strong>
            </p>
          </div>

        </div>

        <div class="comparison-container">
          <div class="comparison-container__item">
            <p>You</p>
            <h3>{{currencyString(comparisonAmount)}}</h3>
          </div>

          <div class="comparison-container__item">
            <p>The average</p>
            <h3>{{currencyString(averageForFilter)}}</h3>
          </div>
        </div>
        <div id="average-container" class="average-container">
          <div class="average-container__block above">Above Average</div>
          <div class="average-container__block">Average</div>
          <div class="average-container__block below">Below Average</div>

          <span id="average-icon" class="average-container__icon" :style="{transform: iconTranslate}">
            <div class="average-container__icon-text">You: {{aboveOrBelowAverageValue}}</div>
          </span>
        </div>

      </span>

      <div class="track-container__inner track-container--actions">

        <h2>Want to take action?</h2>

        <!-- MilitarySuper -->
        <span v-if="scheme === 'MSBS'">

          <div class="advice-block">

            <div class="actionBox">
              <section class="memberServices">
                <span class="img"></span>
                <main>Member services online</main>
                <summary>Login to member services online to check or update your options</summary>
                <nav><a href="https://www.csc.gov.au/Members/Log-in/" target="_blank">Member login <span class="arrow"></span></a></nav>
              </section>
            </div>

          </div>

          <div class="advice-block">
            <h3>Maximising Your Super</h3>
            <p>When it comes to super, you need to be proactive and prepared. We can help you to maximise your super through strategic contributions and smart retirement planning.</p>
            <a href="https://www.csc.gov.au/Members/Superannuation/Maximising-your-super" target="_blank" class="button">Read more</a>
          </div>

          <div class="advice-block">
            <h3>ADF Member Consultations</h3>
            <p>CSC conducts regular superannuation presentations throughout Australia as part of the ADF Transition Seminars program. Attending one of these seminars is a great way to learn more about your scheme.</p>
            <a href="https://www.csc.gov.au/Members/Advice-and-resources/Webinars-and-seminars/ADF-Member-Consultations/militarysuper/" target="_blank" class="button">Read more</a>
          </div>

        </span>

        <span v-if="scheme === 'PSS'">

          <div class="advice-block">

            <div class="actionBox">
              <section class="memberServices">
                <span class="img"></span>
                <main>Member services online</main>
                <summary>Login to member services online to check or update your options</summary>
                <nav><a href="https://www.csc.gov.au/Members/Log-in/" target="_blank">Member login <span class="arrow"></span></a></nav>
              </section>
            </div>

          </div>

          <div class="advice-block">
            <h3>Maximising Your Super</h3>
            <p>When it comes to super, you need to be proactive and prepared. We can help you to maximise your super through strategic contributions and smart retirement planning.</p>
            <a href="https://www.csc.gov.au/Members/Superannuation/Maximising-your-super" target="_blank" class="button">Read more</a>
          </div>

          <div class="advice-block">
            <h3>Webinars and Seminars</h3>
            <p>Everyone learns in different ways. When it’s a topic that’s as complex as super and retirement, we try to ensure you can learn your way whether its face to face or online.</p>
            <a href="https://www.csc.gov.au/Members/Advice-and-resources/Webinars-and-seminars/" target="_blank" class="button">Read more</a>
          </div>

        </span>

        <span v-if="scheme === 'PSSAP'">

          <div class="advice-block">

            <div class="actionBox">
              <section class="modelRetirement">
                <span class="img"></span>
                <main>Model your retirement</main>
                <summary>Project how long your super might last in retirement</summary>
                <nav><a href="https://www.csc.gov.au/Members/Advice-and-resources/Tools/PSSAP-retirement-modeller/pssap/" target="_blank">Model your retirement <span class="arrow"></span></a></nav>
              </section>
            </div>

            <div class="actionBox">
              <section class="memberServices">
                <span class="img"></span>
                <main>Member services online</main>
                <summary>Login to member services online to check or update your options</summary>
                <nav><a href="https://www.csc.gov.au/Members/Log-in/" target="_blank">Member login <span class="arrow"></span></a></nav>
              </section>
            </div>

          </div>

          <div class="advice-block">
            <h3>Maximising Your Super</h3>
            <p>When it comes to super, you need to be proactive and prepared. We can help you to maximise your super through strategic contributions and smart retirement planning.</p>
            <a href="https://www.csc.gov.au/Members/Superannuation/Maximising-your-super" target="_blank" class="button">Read more</a>
          </div>

          <div class="advice-block">
            <h3>Investment</h3>
            <p>At CSC, it’s all about how we can turn our investment earnings into real growth for your super. Everything we do, from how we choose our team to how we invest your money, is with your future in mind.</p>
            <a href="https://www.csc.gov.au/Members/Superannuation/Investment/" target="_blank" class="button">Read more</a>
          </div>

        </span>

        <span v-if="scheme === 'ADFSuper'">

          <div class="advice-block">

            <div class="actionBox">
              <section class="modelRetirement">
                <span class="img"></span>
                <main>Model your retirement</main>
                <summary>Project how long your super might last in retirement</summary>
                <nav><a href="https://www.csc.gov.au/Members/Advice-and-resources/Tools/adf-retirement-modeller/adf-super/" target="_blank">Model your retirement <span class="arrow"></span></a></nav>
              </section>
            </div>

            <div class="actionBox">
              <section class="memberServices">
                <span class="img"></span>
                <main>Member services online</main>
                <summary>Login to member services online to check or update your options</summary>
                <nav><a href="https://www.csc.gov.au/Members/Log-in/" target="_blank">Member login <span class="arrow"></span></a></nav>
              </section>
            </div>

          </div>

          <div class="advice-block">
            <h3>Investing For Your Future</h3>
            <p>At CSC, it’s all about how we can turn our investment earnings into real growth for your super. Everything we do, from how we choose our team to how we invest your money, is with your future in mind.</p>
            <a href="https://www.csc.gov.au/Members/Superannuation/Investment/" target="_blank" class="button">Read more</a>
          </div>

          <div class="advice-block">
            <h3>ADF Member Consultations</h3>
            <p>CSC conducts regular superannuation presentations throughout Australia as part of the ADF Transition Seminars program. Attending one of these seminars is a great way to learn more about your scheme.</p>
            <a href="https://www.csc.gov.au/Members/Advice-and-resources/Webinars-and-seminars/ADF-Member-Consultations/" target="_blank" class="button">Read more</a>
          </div>

        </span>

        <!-- <a href="#" class="button">Learn more</a> -->
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Results',
  data() {
    // Set variables used throughout the App
    return {
      averageContainerHeight: 75,
      showFeedback: true
    };
  },
  computed: {
    ...mapGetters(['getAge', 'getGender', 'getFundBalance', 'getPreTaxContributions', 'getPostTaxContributions', 'getScheme', 'getFilter', 'getFilterList', 'getSwitcher', 'getSwitcherList', 'getAverages', 'getPostcode', 'getPostcodeList']),
    age: {
      get () {
        return this.getAge
      }
    },
    gender: {
      get() {
        return this.getGender;
      }
    },
    fundBalance: {
      get() {
        return this.getFundBalance;
      }
    },
    preTaxContributions: {
      get() {
        return parseInt(this.getPreTaxContributions) ? this.getPreTaxContributions : 0;
      }
    },
    postTaxContributions: {
      get() {
        return parseInt(this.getPostTaxContributions) ? this.getPostTaxContributions : 0;
      }
    },
    scheme: {
      get() {
        return this.getScheme;
      }
    },
    postcode: {
      get() {
        return this.getPostcode;
      }
    },

    filter: {
      get () {
        return this.getFilter
      },
      set (value) {
        this.setFilter(value)
      }
    },

    filterList() {
      let tempFilterList = [];

      // Filter by Age
      if (!this.ageNotInData(this.switcher)) {
        tempFilterList.push(this.getFilterList[0]);
      }

      // Filter by Gender
      if (this.gender !== 'X') {
        tempFilterList.push(this.getFilterList[1]);

        // Filter by Age and Gender
        if ((this.scheme === 'PSSAP' || this.scheme === 'ADFSuper') && !this.ageAndGenderNotInData(this.switcher)) {
          tempFilterList.push(this.getFilterList[2]);
        }
      }

      tempFilterList.push(this.getFilterList[3]);
      return tempFilterList
    },

    switcher: {
      get () {
        return this.getSwitcher
      },
      set (value) {
        this.setSwitcher(value)
      }
    },

    switcherList() {
      let tempSwitcherList = [];
      tempSwitcherList.push(this.getSwitcherList[0]);
      if (this.scheme === 'PSSAP' || this.scheme === 'ADFSuper') {
        switch(this.filter) {
          case "AGE":
            if (!this.ageNotInData(this.getSwitcherList[1])) {
              tempSwitcherList.push(this.getSwitcherList[1]);
            }
            if (!this.ageNotInData(this.getSwitcherList[2])) {
              tempSwitcherList.push(this.getSwitcherList[2]);
            }
            break;

          case "GENDER":
            if (!this.genderNotInData(this.getSwitcherList[1])) {
              tempSwitcherList.push(this.getSwitcherList[1]);
            }
            if (!this.genderNotInData(this.getSwitcherList[2])) {
              tempSwitcherList.push(this.getSwitcherList[2]);
            }
            break;

          case "AGEGENDER":
            if (!this.ageAndGenderNotInData(this.getSwitcherList[1])) {
              tempSwitcherList.push(this.getSwitcherList[1]);
            }
            if (!this.ageAndGenderNotInData(this.getSwitcherList[2])) {
              tempSwitcherList.push(this.getSwitcherList[2]);
            }
            break;

          case "SCHEME":
            if (!this.noValuesInData(this.getSwitcherList[1])) {
              tempSwitcherList.push(this.getSwitcherList[1]);
            }
            if (!this.noValuesInData(this.getSwitcherList[2])) {
              tempSwitcherList.push(this.getSwitcherList[2]);
            }
            break;

          default:
            if (!this.noValuesInData(this.getSwitcherList[1])) {
              tempSwitcherList.push(this.getSwitcherList[1]);
            }
            if (!this.noValuesInData(this.getSwitcherList[2])) {
              tempSwitcherList.push(this.getSwitcherList[2]);
            }
        }
      }
      return tempSwitcherList
    },

    moveToPercent() {
      let percentWithinBoundary = (this.comparisonAmount / this.highValue) * 100;
      percentWithinBoundary = percentWithinBoundary > 100 ? 100 : percentWithinBoundary;
      percentWithinBoundary = percentWithinBoundary < 0 ? 0 : percentWithinBoundary;
      return 100 - percentWithinBoundary
    },

    moveToValue() {
      // alert(this.averageContainerHeight)
      return ((this.averageContainerHeight - 70) / 100) * this.moveToPercent;
    },

    iconTranslate() {
      return 'translateY(' + this.moveToValue + 'px)';
    },

    switcherDescription(){
      switch(this.switcher) {
        case "BALANCE":
          return `balance`
        case "PRETAX":
          return `pre-tax contributions`
        case "POSTTAX":
          return `post-tax contributions`
        default:
          return ``
      }
    },

    prettyFilterDescription(){
      switch(this.filter) {
        case "AGE":
          if (this.age > 65) {
            return 'everyone aged 65 and over'
          } else if (this.age < 18) {
            return 'everyone aged 18 and under'
          }
          return `everyone aged ${this.age}`
        case "GENDER":
          return `${this.prettyGender} members`
        case "AGEGENDER":
          if(this.gender == 'X') {
            return `${this.prettyGender} aged ${this.age}`
          } else {
            return `${this.prettyGender} members aged ${this.age}`
          }
        case "SCHEME":
          return `fellow members of ${this.scheme}`
        case "POSTCODE":
          return `other people who live in ${this.prettyPostcodeName}`
        default:
          return `everyone in ${this.scheme}`
      }
    },

    comparisonAmount() {
      switch(this.switcher) {
        case "BALANCE":
          return this.fundBalance;
        case "PRETAX":
          return parseInt(this.preTaxContributions) ? this.preTaxContributions : 0;
        case "POSTTAX":
          return parseInt(this.postTaxContributions) ? this.postTaxContributions : 0;
        default:
          return this.fundBalance;
      }
    },

    averageForFilter() {
      // DONE but check: Check appropriate dataset value exists
      // DONE but check: Instead of hardcoding balance, use switcher value to switch dataset
      if (!this.noValuesInData(this.switcher)) {
        switch(this.filter) {
          case "AGE":
            if (!this.ageNotInData(this.switcher)) {
              return this.getAverages[this.scheme].dataSet[this.switcher].age[this.ageWithCap];
            } else {
              return false;
            }

          case "GENDER":
            if (!this.genderNotInData(this.switcher)) {
              return this.getAverages[this.scheme].dataSet[this.switcher].gender[this.gender];
            } else {
              return false;
            }

          case "AGEGENDER":
            // Only for PSSAP and ADF
            if (!this.ageAndGenderNotInData(this.switcher)) {
              return this.getAverages[this.scheme].dataSet[this.switcher].ageAndGender[this.gender].age[this.ageWithCap];
            } else {
              return false;
            }

          default:
            return this.getAverages[this.scheme].dataSet[this.switcher].all;
        }
      } else {
        return false;
      }
    },

    prettyGender(){
      if (!this.noValuesInData(this.switcher)) {
        switch(this.gender) {
          case "M":
            return 'male';
          case "F":
            return 'female';
          case "X":
            return 'everyone';
          default:
            return 'everyone';
        }
      } else {
        return false;
      }
    },

    ageWithCap(){
      if (this.age > 65) {
        return 'over65'
      } else if (this.age < 18) {
        return 'under18'
      }
      return this.age
    },

    highValue() {
      return this.averageForFilter * 2;
    },

    prettyPostcodeName() {
      return this.getPostcodeList.filter(obj => {
        return obj.value === this.getPostcode
      })[0].text
    },

    filledInInputs() {
      return this.getAge > 0 && this.getFundBalance >= 0 && this.getScheme != '' && this.getGender != ''
    },

    aboveOrBelowAverageValue() {
      const difference = this.comparisonAmount - this.averageForFilter;
      const shownDifference = difference < 0 ? difference * -1 : difference;
      return `${this.currencyString(shownDifference)} ${difference < 0 ? 'below' : 'above'} average`;
    }
  },

  methods: {
    ...mapMutations(['setFilter','setSwitcher']),

    iconMove() {
      this.highValue += 50;
    },

    currencyString(val) {
      return '$' + parseInt(val).toLocaleString();
    },

    track () {
      this.$ga.page('/results')
    },

    ageNotInData(currentSwitchVal) {
      if (typeof currentSwitchVal === "object") currentSwitchVal = currentSwitchVal.value;
      return (
        this.getAverages[this.scheme].dataSet[currentSwitchVal] === undefined ||
        this.getAverages[this.scheme].dataSet[currentSwitchVal].age[this.ageWithCap] === undefined
      );
    },

    genderNotInData(currentSwitchVal) {
      if (typeof currentSwitchVal === "object") currentSwitchVal = currentSwitchVal.value;
      return (
        this.getAverages[this.scheme].dataSet[currentSwitchVal] === undefined ||
        this.getAverages[this.scheme].dataSet[currentSwitchVal].gender[this.gender] === undefined
      );
    },

    ageAndGenderNotInData(currentSwitchVal) {
      if (typeof currentSwitchVal === "object") currentSwitchVal = currentSwitchVal.value;
      return (
        this.getAverages[this.scheme].dataSet[currentSwitchVal] === undefined ||
        this.getAverages[this.scheme].dataSet[currentSwitchVal].ageAndGender[this.gender].age[this.ageWithCap] === undefined
      );
    },

    noValuesInData(currentSwitchVal) {
      if (typeof currentSwitchVal === "object") currentSwitchVal = currentSwitchVal.value;
      return (
        this.getAverages[this.scheme].dataSet[currentSwitchVal] === undefined
      );
    }
  },

  mounted() {
    if(this.filledInInputs === false) {
      this.$router.push('Welcome');
    }
    this.filter = this.filterList[0].value;
    this.switcher = this.switcherList[0].value;
    this.averageContainerHeight = document.getElementById('average-container').offsetHeight;
  }
}
</script>